var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"angio-pdf"},[_c('iframe',{ref:"iframe",staticClass:"pdf-iframe",attrs:{"id":"iframe","src":_vm.pdfUrl,"frameborder":"0","scrolling":"no"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }